import { useQuery } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";

const API = process.env.REACT_APP_API;

export interface MonthlySale {
  month: string;
  total_gross: string;
}

export function useMonthlySales(params: { year?: number }) {
  const fetch = useFetch();
  const search = new URLSearchParams(
    params as Record<string, string>,
  ).toString();

  return useQuery<MonthlySale[]>({
    queryKey: ["monthly-sales", params],
    queryFn: () =>
      fetch(`${API}/api/semeadora/reports/sales/monthly/?${search}`),
  });
}
